'use client';

import { useCallback, useMemo } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';
import { IconView } from '@personly/libs-widgets';

import { useConsents } from '@/providers/consents';

const className = classnames(
  'flex',
  'flex-row',
  'text-sm',
  'cursor-pointer',
  'opacity-45',
  'border-background-title-color'
);

interface Props {
  icon?: Icon;
  hideSettings: string;
  showSettings: string;
}

const ConsentSettingsToggle = ({ icon, hideSettings, showSettings }: Props) => {
  const { consentSettingsOpen, setConsentSettingsOpen } = useConsents();

  const text = useMemo(
    () => (consentSettingsOpen ? hideSettings : showSettings),
    [consentSettingsOpen, hideSettings, showSettings]
  );

  const onClick = useCallback(
    () => setConsentSettingsOpen((value) => !value),
    [setConsentSettingsOpen]
  );

  return (
    <div className={className} onClick={() => onClick()}>
      <div className="pr-1">
        <IconView icon={icon} fixedWidth size={'xl'} />
      </div>
      <div>{text}</div>
    </div>
  );
};

export default ConsentSettingsToggle;
